import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import { store as userStore } from "@components/VerticalLayout/store";
import { generalConfigStore } from "@store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { setKey } from "../store";

type CardFooterListShopType = {
    dataListShops: any;
    rowData: any;
    setIsModalAssociateStore: Function;
    isModalAssociateStore: boolean;
    setLimit: Function;
    setRowData: Function;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export default function CardFooterListShop({
    dataListShops,
    rowData,
    setIsModalAssociateStore,
    isModalAssociateStore,
    setRowData,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: CardFooterListShopType) {
    const { t } = useTranslation();
    const { userID, franchiseID } = useSnapshot(userStore);
    const { project, itemsDisable } = useSnapshot(generalConfigStore);
    const [
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
    ] = React.useState<boolean>(false);

    async function handleSaveProjectShopIds() {
        const api = `${process.env.REACT_APP_API_V2_URL}/settings/project/associate`;
        let savedData: any = {
            franchiseId: franchiseID,
            shopId: {},
            userId: userID,
            itemsDisable,
            t,
            projectId: [project.projectId],
        };

        dataListShops.forEach(async (el: any) => {
            if (!rowData.shopKey.includes(el.id_boutique)) {
                savedData.shopId[el.id_boutique] = el.Boutique;
            }
        });
        setIsModalAssociateStore(!isModalAssociateStore);

        try {
            if (Object.keys(savedData.shopId).length > 0) {
                setIsModalLoadingOpened(true);
                setModalLoadingData({
                    title: "Associate in progress",
                    message: "the associate of the template is in progress",
                });
                await fetch(api, {
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bareer ${localStorage.getItem("jwt")}`,
                    },
                    body: JSON.stringify(savedData),
                    method: "POST",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error("Error while saving selection !");
                        } else {
                            setIsModalLoadingOpened(false);
                            const allTrue = Object.values(
                                data.shopsListNotAssociate
                            ).every((value) => value === true);

                            if (allTrue) {
                                return toast.warning(
                                    `${t(
                                        `Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings.`
                                    )!}`,
                                    {
                                        position: toast.POSITION.TOP_CENTER,
                                        autoClose: 2000,
                                        theme: "colored",
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        icon: (
                                            <CheckboxIcon
                                                height={25}
                                                width={25}
                                                fill="white"
                                            />
                                        ),
                                    }
                                );
                            } else {
                                let someTrue = Object.values(
                                    data.shopsListNotAssociate
                                ).some((value) => value === true);
                                if (someTrue) {
                                    toast.warning(
                                        `${t(
                                            `Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings.`
                                        )!}`,
                                        {
                                            position: toast.POSITION.TOP_CENTER,
                                            autoClose: 1000,
                                            theme: "colored",
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            icon: (
                                                <CheckboxIcon
                                                    height={25}
                                                    width={25}
                                                    fill="white"
                                                />
                                            ),
                                        }
                                    );
                                }

                                toast.success(
                                    `${t("Store assignment was successful")!}`,
                                    {
                                        position: toast.POSITION.TOP_CENTER,
                                        autoClose: 2000,
                                        theme: "colored",
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        icon: (
                                            <CheckboxIcon
                                                height={25}
                                                width={25}
                                                fill="white"
                                            />
                                        ),
                                    }
                                );

                                setKey(Math.floor(Math.random() * 10000));
                            }
                        }
                    });
            }
        } catch (e: any) {
            setIsModalLoadingOpened(false);
            toast.error(`${t("There's an error ")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    return (
        <div>
            <div className="justify-content-between d-flex align-items-right  float-right p-3 mt-3">
                <CustomSecondaryColorButton
                    outline
                    rounded
                    className="mr-2 cmn_icn_closeAlert"
                    variant="light"
                    onClick={() => {
                        setIsModalAssociateStore(!isModalAssociateStore);
                        setRowData([]);
                    }}
                >
                    <span> {t("Cancel")}</span>
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    disabled={isValidateButtonDisabled}
                    variant="primary"
                    className="cmn_btn_validateAlert"
                    onClick={() => {
                        if (dataListShops.length > 0) {
                            setIsValidateButtonDisabled(true);
                            handleSaveProjectShopIds();
                        } else {
                            setIsModalAssociateStore(false);
                            setRowData([]);
                        }
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </div>
        </div>
    );
}
